import { BillsToReciveList } from './pages/billsToReceiveList';

export const BillsToRecieveRoutes = [
  {
    path: '/financeiro/contas-a-receber',
    exact: true,
    component: BillsToReciveList,
  },
];
